var Ur = Object.defineProperty;
var Xr = (t, r, e) => r in t ? Ur(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e;
var x = (t, r, e) => (Xr(t, typeof r != "symbol" ? r + "" : r, e), e);
import sr from "react";
var St = { exports: {} }, nt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qt;
function Jr() {
  if (Qt)
    return nt;
  Qt = 1;
  var t = sr, r = Symbol.for("react.element"), e = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, g, y) {
    var k, R = {}, b = null, E = null;
    y !== void 0 && (b = "" + y), g.key !== void 0 && (b = "" + g.key), g.ref !== void 0 && (E = g.ref);
    for (k in g)
      n.call(g, k) && !u.hasOwnProperty(k) && (R[k] = g[k]);
    if (f && f.defaultProps)
      for (k in g = f.defaultProps, g)
        R[k] === void 0 && (R[k] = g[k]);
    return { $$typeof: r, type: f, key: b, ref: E, props: R, _owner: o.current };
  }
  return nt.Fragment = e, nt.jsx = l, nt.jsxs = l, nt;
}
var it = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bt;
function qr() {
  return Bt || (Bt = 1, process.env.NODE_ENV !== "production" && function() {
    var t = sr, r = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), f = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), k = Symbol.for("react.suspense_list"), R = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), T = Symbol.iterator, L = "@@iterator";
    function cr(i) {
      if (i === null || typeof i != "object")
        return null;
      var c = T && i[T] || i[L];
      return typeof c == "function" ? c : null;
    }
    var B = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function M(i) {
      {
        for (var c = arguments.length, d = new Array(c > 1 ? c - 1 : 0), h = 1; h < c; h++)
          d[h - 1] = arguments[h];
        fr("error", i, d);
      }
    }
    function fr(i, c, d) {
      {
        var h = B.ReactDebugCurrentFrame, v = h.getStackAddendum();
        v !== "" && (c += "%s", d = d.concat([v]));
        var p = d.map(function($) {
          return String($);
        });
        p.unshift("Warning: " + c), Function.prototype.apply.call(console[i], console, p);
      }
    }
    var dr = !1, gr = !1, yr = !1, xr = !1, hr = !1, Ot;
    Ot = Symbol.for("react.module.reference");
    function mr(i) {
      return !!(typeof i == "string" || typeof i == "function" || i === n || i === u || hr || i === o || i === y || i === k || xr || i === E || dr || gr || yr || typeof i == "object" && i !== null && (i.$$typeof === b || i.$$typeof === R || i.$$typeof === l || i.$$typeof === f || i.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      i.$$typeof === Ot || i.getModuleId !== void 0));
    }
    function $r(i, c, d) {
      var h = i.displayName;
      if (h)
        return h;
      var v = c.displayName || c.name || "";
      return v !== "" ? d + "(" + v + ")" : d;
    }
    function Pt(i) {
      return i.displayName || "Context";
    }
    function Y(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && M("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case n:
          return "Fragment";
        case e:
          return "Portal";
        case u:
          return "Profiler";
        case o:
          return "StrictMode";
        case y:
          return "Suspense";
        case k:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case f:
            var c = i;
            return Pt(c) + ".Consumer";
          case l:
            var d = i;
            return Pt(d._context) + ".Provider";
          case g:
            return $r(i, i.render, "ForwardRef");
          case R:
            var h = i.displayName || null;
            return h !== null ? h : Y(i.type) || "Memo";
          case b: {
            var v = i, p = v._payload, $ = v._init;
            try {
              return Y($(p));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, rt = 0, Rt, Mt, Ct, Tt, Wt, Lt, Dt;
    function _t() {
    }
    _t.__reactDisabledLog = !0;
    function kr() {
      {
        if (rt === 0) {
          Rt = console.log, Mt = console.info, Ct = console.warn, Tt = console.error, Wt = console.group, Lt = console.groupCollapsed, Dt = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: _t,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        rt++;
      }
    }
    function vr() {
      {
        if (rt--, rt === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, i, {
              value: Rt
            }),
            info: K({}, i, {
              value: Mt
            }),
            warn: K({}, i, {
              value: Ct
            }),
            error: K({}, i, {
              value: Tt
            }),
            group: K({}, i, {
              value: Wt
            }),
            groupCollapsed: K({}, i, {
              value: Lt
            }),
            groupEnd: K({}, i, {
              value: Dt
            })
          });
        }
        rt < 0 && M("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ht = B.ReactCurrentDispatcher, mt;
    function at(i, c, d) {
      {
        if (mt === void 0)
          try {
            throw Error();
          } catch (v) {
            var h = v.stack.trim().match(/\n( *(at )?)/);
            mt = h && h[1] || "";
          }
        return `
` + mt + i;
      }
    }
    var $t = !1, ut;
    {
      var wr = typeof WeakMap == "function" ? WeakMap : Map;
      ut = new wr();
    }
    function Ft(i, c) {
      if (!i || $t)
        return "";
      {
        var d = ut.get(i);
        if (d !== void 0)
          return d;
      }
      var h;
      $t = !0;
      var v = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var p;
      p = ht.current, ht.current = null, kr();
      try {
        if (c) {
          var $ = function() {
            throw Error();
          };
          if (Object.defineProperty($.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($, []);
            } catch (I) {
              h = I;
            }
            Reflect.construct(i, [], $);
          } else {
            try {
              $.call();
            } catch (I) {
              h = I;
            }
            i.call($.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (I) {
            h = I;
          }
          i();
        }
      } catch (I) {
        if (I && h && typeof I.stack == "string") {
          for (var m = I.stack.split(`
`), C = h.stack.split(`
`), O = m.length - 1, P = C.length - 1; O >= 1 && P >= 0 && m[O] !== C[P]; )
            P--;
          for (; O >= 1 && P >= 0; O--, P--)
            if (m[O] !== C[P]) {
              if (O !== 1 || P !== 1)
                do
                  if (O--, P--, P < 0 || m[O] !== C[P]) {
                    var W = `
` + m[O].replace(" at new ", " at ");
                    return i.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", i.displayName)), typeof i == "function" && ut.set(i, W), W;
                  }
                while (O >= 1 && P >= 0);
              break;
            }
        }
      } finally {
        $t = !1, ht.current = p, vr(), Error.prepareStackTrace = v;
      }
      var tt = i ? i.displayName || i.name : "", Ht = tt ? at(tt) : "";
      return typeof i == "function" && ut.set(i, Ht), Ht;
    }
    function pr(i, c, d) {
      return Ft(i, !1);
    }
    function jr(i) {
      var c = i.prototype;
      return !!(c && c.isReactComponent);
    }
    function ct(i, c, d) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return Ft(i, jr(i));
      if (typeof i == "string")
        return at(i);
      switch (i) {
        case y:
          return at("Suspense");
        case k:
          return at("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case g:
            return pr(i.render);
          case R:
            return ct(i.type, c, d);
          case b: {
            var h = i, v = h._payload, p = h._init;
            try {
              return ct(p(v), c, d);
            } catch {
            }
          }
        }
      return "";
    }
    var ft = Object.prototype.hasOwnProperty, zt = {}, Yt = B.ReactDebugCurrentFrame;
    function dt(i) {
      if (i) {
        var c = i._owner, d = ct(i.type, i._source, c ? c.type : null);
        Yt.setExtraStackFrame(d);
      } else
        Yt.setExtraStackFrame(null);
    }
    function Sr(i, c, d, h, v) {
      {
        var p = Function.call.bind(ft);
        for (var $ in i)
          if (p(i, $)) {
            var m = void 0;
            try {
              if (typeof i[$] != "function") {
                var C = Error((h || "React class") + ": " + d + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw C.name = "Invariant Violation", C;
              }
              m = i[$](c, $, h, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (O) {
              m = O;
            }
            m && !(m instanceof Error) && (dt(v), M("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", h || "React class", d, $, typeof m), dt(null)), m instanceof Error && !(m.message in zt) && (zt[m.message] = !0, dt(v), M("Failed %s type: %s", d, m.message), dt(null));
          }
      }
    }
    var br = Array.isArray;
    function kt(i) {
      return br(i);
    }
    function Er(i) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, d = c && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return d;
      }
    }
    function Or(i) {
      try {
        return It(i), !1;
      } catch {
        return !0;
      }
    }
    function It(i) {
      return "" + i;
    }
    function At(i) {
      if (Or(i))
        return M("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Er(i)), It(i);
    }
    var et = B.ReactCurrentOwner, Pr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Nt, Gt, vt;
    vt = {};
    function Rr(i) {
      if (ft.call(i, "ref")) {
        var c = Object.getOwnPropertyDescriptor(i, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return i.ref !== void 0;
    }
    function Mr(i) {
      if (ft.call(i, "key")) {
        var c = Object.getOwnPropertyDescriptor(i, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return i.key !== void 0;
    }
    function Cr(i, c) {
      if (typeof i.ref == "string" && et.current && c && et.current.stateNode !== c) {
        var d = Y(et.current.type);
        vt[d] || (M('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(et.current.type), i.ref), vt[d] = !0);
      }
    }
    function Tr(i, c) {
      {
        var d = function() {
          Nt || (Nt = !0, M("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        d.isReactWarning = !0, Object.defineProperty(i, "key", {
          get: d,
          configurable: !0
        });
      }
    }
    function Wr(i, c) {
      {
        var d = function() {
          Gt || (Gt = !0, M("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        d.isReactWarning = !0, Object.defineProperty(i, "ref", {
          get: d,
          configurable: !0
        });
      }
    }
    var Lr = function(i, c, d, h, v, p, $) {
      var m = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: i,
        key: c,
        ref: d,
        props: $,
        // Record the component responsible for creating this element.
        _owner: p
      };
      return m._store = {}, Object.defineProperty(m._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(m, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.defineProperty(m, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.freeze && (Object.freeze(m.props), Object.freeze(m)), m;
    };
    function Dr(i, c, d, h, v) {
      {
        var p, $ = {}, m = null, C = null;
        d !== void 0 && (At(d), m = "" + d), Mr(c) && (At(c.key), m = "" + c.key), Rr(c) && (C = c.ref, Cr(c, v));
        for (p in c)
          ft.call(c, p) && !Pr.hasOwnProperty(p) && ($[p] = c[p]);
        if (i && i.defaultProps) {
          var O = i.defaultProps;
          for (p in O)
            $[p] === void 0 && ($[p] = O[p]);
        }
        if (m || C) {
          var P = typeof i == "function" ? i.displayName || i.name || "Unknown" : i;
          m && Tr($, P), C && Wr($, P);
        }
        return Lr(i, m, C, v, h, et.current, $);
      }
    }
    var wt = B.ReactCurrentOwner, Ut = B.ReactDebugCurrentFrame;
    function V(i) {
      if (i) {
        var c = i._owner, d = ct(i.type, i._source, c ? c.type : null);
        Ut.setExtraStackFrame(d);
      } else
        Ut.setExtraStackFrame(null);
    }
    var pt;
    pt = !1;
    function jt(i) {
      return typeof i == "object" && i !== null && i.$$typeof === r;
    }
    function Xt() {
      {
        if (wt.current) {
          var i = Y(wt.current.type);
          if (i)
            return `

Check the render method of \`` + i + "`.";
        }
        return "";
      }
    }
    function _r(i) {
      {
        if (i !== void 0) {
          var c = i.fileName.replace(/^.*[\\\/]/, ""), d = i.lineNumber;
          return `

Check your code at ` + c + ":" + d + ".";
        }
        return "";
      }
    }
    var Jt = {};
    function Fr(i) {
      {
        var c = Xt();
        if (!c) {
          var d = typeof i == "string" ? i : i.displayName || i.name;
          d && (c = `

Check the top-level render call using <` + d + ">.");
        }
        return c;
      }
    }
    function qt(i, c) {
      {
        if (!i._store || i._store.validated || i.key != null)
          return;
        i._store.validated = !0;
        var d = Fr(c);
        if (Jt[d])
          return;
        Jt[d] = !0;
        var h = "";
        i && i._owner && i._owner !== wt.current && (h = " It was passed a child from " + Y(i._owner.type) + "."), V(i), M('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, h), V(null);
      }
    }
    function Kt(i, c) {
      {
        if (typeof i != "object")
          return;
        if (kt(i))
          for (var d = 0; d < i.length; d++) {
            var h = i[d];
            jt(h) && qt(h, c);
          }
        else if (jt(i))
          i._store && (i._store.validated = !0);
        else if (i) {
          var v = cr(i);
          if (typeof v == "function" && v !== i.entries)
            for (var p = v.call(i), $; !($ = p.next()).done; )
              jt($.value) && qt($.value, c);
        }
      }
    }
    function zr(i) {
      {
        var c = i.type;
        if (c == null || typeof c == "string")
          return;
        var d;
        if (typeof c == "function")
          d = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === R))
          d = c.propTypes;
        else
          return;
        if (d) {
          var h = Y(c);
          Sr(d, i.props, "prop", h, i);
        } else if (c.PropTypes !== void 0 && !pt) {
          pt = !0;
          var v = Y(c);
          M("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", v || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && M("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Yr(i) {
      {
        for (var c = Object.keys(i.props), d = 0; d < c.length; d++) {
          var h = c[d];
          if (h !== "children" && h !== "key") {
            V(i), M("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", h), V(null);
            break;
          }
        }
        i.ref !== null && (V(i), M("Invalid attribute `ref` supplied to `React.Fragment`."), V(null));
      }
    }
    function Zt(i, c, d, h, v, p) {
      {
        var $ = mr(i);
        if (!$) {
          var m = "";
          (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (m += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var C = _r(v);
          C ? m += C : m += Xt();
          var O;
          i === null ? O = "null" : kt(i) ? O = "array" : i !== void 0 && i.$$typeof === r ? (O = "<" + (Y(i.type) || "Unknown") + " />", m = " Did you accidentally export a JSX literal instead of a component?") : O = typeof i, M("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", O, m);
        }
        var P = Dr(i, c, d, v, p);
        if (P == null)
          return P;
        if ($) {
          var W = c.children;
          if (W !== void 0)
            if (h)
              if (kt(W)) {
                for (var tt = 0; tt < W.length; tt++)
                  Kt(W[tt], i);
                Object.freeze && Object.freeze(W);
              } else
                M("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Kt(W, i);
        }
        return i === n ? Yr(P) : zr(P), P;
      }
    }
    function Ir(i, c, d) {
      return Zt(i, c, d, !0);
    }
    function Ar(i, c, d) {
      return Zt(i, c, d, !1);
    }
    var Nr = Ar, Gr = Ir;
    it.Fragment = n, it.jsx = Nr, it.jsxs = Gr;
  }()), it;
}
process.env.NODE_ENV === "production" ? St.exports = Jr() : St.exports = qr();
var s = St.exports;
const A = Symbol.for("@ts-pattern/matcher"), Kr = Symbol.for("@ts-pattern/isVariadic"), yt = "@ts-pattern/anonymous-select-key", bt = (t) => !!(t && typeof t == "object"), gt = (t) => t && !!t[A], z = (t, r, e) => {
  if (gt(t)) {
    const n = t[A](), { matched: o, selections: u } = n.match(r);
    return o && u && Object.keys(u).forEach((l) => e(l, u[l])), o;
  }
  if (bt(t)) {
    if (!bt(r))
      return !1;
    if (Array.isArray(t)) {
      if (!Array.isArray(r))
        return !1;
      let n = [], o = [], u = [];
      for (const l of t.keys()) {
        const f = t[l];
        gt(f) && f[Kr] ? u.push(f) : u.length ? o.push(f) : n.push(f);
      }
      if (u.length) {
        if (u.length > 1)
          throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
        if (r.length < n.length + o.length)
          return !1;
        const l = r.slice(0, n.length), f = o.length === 0 ? [] : r.slice(-o.length), g = r.slice(n.length, o.length === 0 ? 1 / 0 : -o.length);
        return n.every((y, k) => z(y, l[k], e)) && o.every((y, k) => z(y, f[k], e)) && (u.length === 0 || z(u[0], g, e));
      }
      return t.length === r.length && t.every((l, f) => z(l, r[f], e));
    }
    return Object.keys(t).every((n) => {
      const o = t[n];
      return (n in r || gt(u = o) && u[A]().matcherType === "optional") && z(o, r[n], e);
      var u;
    });
  }
  return Object.is(r, t);
}, J = (t) => {
  var r, e, n;
  return bt(t) ? gt(t) ? (r = (e = (n = t[A]()).getSelectionKeys) == null ? void 0 : e.call(n)) != null ? r : [] : Array.isArray(t) ? st(t, J) : st(Object.values(t), J) : [];
}, st = (t, r) => t.reduce((e, n) => e.concat(r(n)), []);
function D(t) {
  return Object.assign(t, { optional: () => Zr(t), and: (r) => S(t, r), or: (r) => Hr(t, r), select: (r) => r === void 0 ? Vt(t) : Vt(r, t) });
}
function Zr(t) {
  return D({ [A]: () => ({ match: (r) => {
    let e = {};
    const n = (o, u) => {
      e[o] = u;
    };
    return r === void 0 ? (J(t).forEach((o) => n(o, void 0)), { matched: !0, selections: e }) : { matched: z(t, r, n), selections: e };
  }, getSelectionKeys: () => J(t), matcherType: "optional" }) });
}
function S(...t) {
  return D({ [A]: () => ({ match: (r) => {
    let e = {};
    const n = (o, u) => {
      e[o] = u;
    };
    return { matched: t.every((o) => z(o, r, n)), selections: e };
  }, getSelectionKeys: () => st(t, J), matcherType: "and" }) });
}
function Hr(...t) {
  return D({ [A]: () => ({ match: (r) => {
    let e = {};
    const n = (o, u) => {
      e[o] = u;
    };
    return st(t, J).forEach((o) => n(o, void 0)), { matched: t.some((o) => z(o, r, n)), selections: e };
  }, getSelectionKeys: () => st(t, J), matcherType: "or" }) });
}
function w(t) {
  return { [A]: () => ({ match: (r) => ({ matched: !!t(r) }) }) };
}
function Vt(...t) {
  const r = typeof t[0] == "string" ? t[0] : void 0, e = t.length === 2 ? t[1] : typeof t[0] == "string" ? void 0 : t[0];
  return D({ [A]: () => ({ match: (n) => {
    let o = { [r ?? yt]: n };
    return { matched: e === void 0 || z(e, n, (u, l) => {
      o[u] = l;
    }), selections: o };
  }, getSelectionKeys: () => [r ?? yt].concat(e === void 0 ? [] : J(e)) }) });
}
function _(t) {
  return typeof t == "number";
}
function Z(t) {
  return typeof t == "string";
}
function U(t) {
  return typeof t == "bigint";
}
D(w(function(t) {
  return !0;
}));
const H = (t) => Object.assign(D(t), { startsWith: (r) => {
  return H(S(t, (e = r, w((n) => Z(n) && n.startsWith(e)))));
  var e;
}, endsWith: (r) => {
  return H(S(t, (e = r, w((n) => Z(n) && n.endsWith(e)))));
  var e;
}, minLength: (r) => H(S(t, ((e) => w((n) => Z(n) && n.length >= e))(r))), maxLength: (r) => H(S(t, ((e) => w((n) => Z(n) && n.length <= e))(r))), includes: (r) => {
  return H(S(t, (e = r, w((n) => Z(n) && n.includes(e)))));
  var e;
}, regex: (r) => {
  return H(S(t, (e = r, w((n) => Z(n) && !!n.match(e)))));
  var e;
} });
H(w(Z));
const F = (t) => Object.assign(D(t), { between: (r, e) => F(S(t, ((n, o) => w((u) => _(u) && n <= u && o >= u))(r, e))), lt: (r) => F(S(t, ((e) => w((n) => _(n) && n < e))(r))), gt: (r) => F(S(t, ((e) => w((n) => _(n) && n > e))(r))), lte: (r) => F(S(t, ((e) => w((n) => _(n) && n <= e))(r))), gte: (r) => F(S(t, ((e) => w((n) => _(n) && n >= e))(r))), int: () => F(S(t, w((r) => _(r) && Number.isInteger(r)))), finite: () => F(S(t, w((r) => _(r) && Number.isFinite(r)))), positive: () => F(S(t, w((r) => _(r) && r > 0))), negative: () => F(S(t, w((r) => _(r) && r < 0))) });
F(w(_));
const X = (t) => Object.assign(D(t), { between: (r, e) => X(S(t, ((n, o) => w((u) => U(u) && n <= u && o >= u))(r, e))), lt: (r) => X(S(t, ((e) => w((n) => U(n) && n < e))(r))), gt: (r) => X(S(t, ((e) => w((n) => U(n) && n > e))(r))), lte: (r) => X(S(t, ((e) => w((n) => U(n) && n <= e))(r))), gte: (r) => X(S(t, ((e) => w((n) => U(n) && n >= e))(r))), positive: () => X(S(t, w((r) => U(r) && r > 0))), negative: () => X(S(t, w((r) => U(r) && r < 0))) });
X(w(U));
D(w(function(t) {
  return typeof t == "boolean";
}));
D(w(function(t) {
  return typeof t == "symbol";
}));
D(w(function(t) {
  return t == null;
}));
const Et = { matched: !1, value: void 0 };
function Q(t) {
  return new xt(t, Et);
}
class xt {
  constructor(r, e) {
    this.input = void 0, this.state = void 0, this.input = r, this.state = e;
  }
  with(...r) {
    if (this.state.matched)
      return this;
    const e = r[r.length - 1], n = [r[0]];
    let o;
    r.length === 3 && typeof r[1] == "function" ? (n.push(r[0]), o = r[1]) : r.length > 2 && n.push(...r.slice(1, r.length - 1));
    let u = !1, l = {};
    const f = (y, k) => {
      u = !0, l[y] = k;
    }, g = !n.some((y) => z(y, this.input, f)) || o && !o(this.input) ? Et : { matched: !0, value: e(u ? yt in l ? l[yt] : l : this.input, this.input) };
    return new xt(this.input, g);
  }
  when(r, e) {
    if (this.state.matched)
      return this;
    const n = !!r(this.input);
    return new xt(this.input, n ? { matched: !0, value: e(this.input, this.input) } : Et);
  }
  otherwise(r) {
    return this.state.matched ? this.state.value : r(this.input);
  }
  exhaustive() {
    return this.run();
  }
  run() {
    if (this.state.matched)
      return this.state.value;
    let r;
    try {
      r = JSON.stringify(this.input);
    } catch {
      r = this.input;
    }
    throw new Error(`Pattern matching error: no pattern matches value ${r}`);
  }
  returnType() {
    return this;
  }
}
let Qr = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((r, e) => (e &= 63, e < 36 ? r += e.toString(36) : e < 62 ? r += (e - 26).toString(36).toUpperCase() : e > 62 ? r += "-" : r += "_", r), "");
function lr(t, r) {
  switch (t) {
    case "left":
      return 0;
    case "center":
      return r / 2;
    case "right":
      return r;
  }
}
function ar(t) {
  switch (t) {
    case "left":
      return "start";
    case "center":
      return "middle";
    case "right":
      return "end";
  }
}
function Br(t) {
  var f;
  const r = (f = t.text) == null ? void 0 : f.split(`
`), { id: e, element: n } = G(t.width, t.height), { textAlign: o = "left" } = t, u = lr(o, t.width), l = ar(o);
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    n,
    /* @__PURE__ */ s.jsx(
      "g",
      {
        clipPath: `url(#clip_${e})`,
        style: {
          transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
          transformOrigin: `${t.width / 2}px ${t.height / 2}px`
        },
        children: /* @__PURE__ */ s.jsx(
          "text",
          {
            textAnchor: l,
            width: t.width + "px",
            dominantBaseline: "text-before-edge",
            style: {
              userSelect: "none"
            },
            children: r == null ? void 0 : r.map((g, y) => /* @__PURE__ */ s.jsx(
              "tspan",
              {
                fill: t.textColor ?? "#fff",
                fontSize: t.textSize ?? 14,
                y: (t.textSize ?? 14) * y,
                x: u,
                children: g
              },
              y
            ))
          }
        )
      }
    )
  ] });
}
function N(t) {
  var l;
  const { textAlign: r = "center" } = t, e = (l = t.text) == null ? void 0 : l.split(`
`), n = t.textSize ?? 14, o = lr(r, t.width), u = ar(r);
  return /* @__PURE__ */ s.jsx(
    "text",
    {
      textAnchor: u,
      width: t.width + "px",
      dominantBaseline: "middle",
      style: {
        userSelect: "none"
      },
      children: e == null ? void 0 : e.map((f, g) => /* @__PURE__ */ s.jsx(
        "tspan",
        {
          fill: t.textColor ?? "#fff",
          fontSize: n,
          x: o,
          y: n * g + t.height / 2 - (e.length - 1) * n / 2,
          children: f
        },
        g
      ))
    }
  );
}
function G(t, r, e) {
  const n = Qr(), o = t + (e ?? 0), u = r + (e ?? 0), l = /* @__PURE__ */ s.jsx("clipPath", { id: `clip_${n}`, children: /* @__PURE__ */ s.jsx(
    "rect",
    {
      width: o,
      height: u,
      x: -(e ?? 0) / 2,
      y: -(e ?? 0) / 2
    }
  ) });
  return { id: n, element: l };
}
function j(t) {
  return Q(t).with("solid", () => "0").with("dashed", () => "5 5").with("dotted", () => "1 5").exhaustive();
}
function Vr(t) {
  const { id: r, element: e } = G(
    t.width,
    t.height,
    t.strokeWidth
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e,
    /* @__PURE__ */ s.jsxs(
      "g",
      {
        clipPath: `url(#clip_${r})`,
        style: {
          transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
          transformOrigin: `${t.width / 2}px ${t.height / 2}px`
        },
        children: [
          /* @__PURE__ */ s.jsx(
            "rect",
            {
              width: t.width,
              height: t.height,
              fill: t.fill,
              rx: t.radius,
              strokeWidth: t.strokeWidth ?? 0,
              stroke: t.stroke,
              strokeDasharray: t.strokeStyle && j(t.strokeStyle)
            }
          ),
          t.text && /* @__PURE__ */ s.jsx(
            N,
            {
              text: t.text,
              width: t.width,
              height: t.height,
              textColor: t.textColor,
              textSize: t.textSize,
              textAlign: t.textAlign
            }
          )
        ]
      }
    )
  ] });
}
function te(t) {
  const { id: r, element: e } = G(
    t.width,
    t.height,
    t.strokeWidth
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e,
    /* @__PURE__ */ s.jsxs(
      "g",
      {
        clipPath: `url(#clip_${r})`,
        style: {
          transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
          transformOrigin: `${t.width / 2}px ${t.height / 2}px`
        },
        children: [
          /* @__PURE__ */ s.jsx("g", { transform: `translate(${t.width / 2}, ${t.height / 2})`, children: /* @__PURE__ */ s.jsx(
            "ellipse",
            {
              width: t.width,
              height: t.height,
              fill: t.fill,
              rx: t.width / 2,
              ry: t.height / 2,
              strokeWidth: t.strokeWidth ?? 1,
              stroke: t.stroke
            }
          ) }),
          t.text && /* @__PURE__ */ s.jsx(
            N,
            {
              text: t.text,
              width: t.width,
              height: t.height,
              textColor: t.textColor,
              textSize: t.textSize,
              textAlign: t.textAlign
            }
          )
        ]
      }
    )
  ] });
}
let re = 0;
function q(t, r) {
  const e = `atom${++re}`, n = {
    toString: () => e
  };
  return typeof t == "function" ? n.read = t : (n.init = t, n.read = ee, n.write = ne), r && (n.write = r), n;
}
function ee(t) {
  return t(this);
}
function ne(t, r, e) {
  return r(
    this,
    typeof e == "function" ? e(t(this)) : e
  );
}
q(null);
q([]);
q("select");
q(null);
q(null);
q(null);
q(null);
q(null);
const a = class a {
  static clamp(r, e, n) {
    return Math.max(e, typeof n < "u" ? Math.min(r, n) : r);
  }
  static clampV(r, e, n) {
    return r.map((o) => n ? a.clamp(o, e, n) : a.clamp(o, e));
  }
  /**
   * Cross (for point in polygon)
   *
   */
  static cross(r, e, n) {
    return (e[0] - r[0]) * (n[1] - r[1]) - (n[0] - r[0]) * (e[1] - r[1]);
  }
  /**
   * Snap vector to nearest step.
   * @param A
   * @param step
   * @example
   * ```ts
   * Vec.snap([10.5, 28], 10) // [10, 30]
   * ```
   */
  static snap(r, e = 1) {
    return [Math.round(r[0] / e) * e, Math.round(r[1] / e) * e];
  }
};
/**
 * Negate a vector.
 * @param A
 */
x(a, "neg", (r) => [-r[0], -r[1]]), /**
 * Add vectors.
 * @param A
 * @param B
 */
x(a, "add", (r, e) => [r[0] + e[0], r[1] + e[1]]), /**
 * Add scalar to vector.
 * @param A
 * @param B
 */
x(a, "addScalar", (r, e) => [r[0] + e, r[1] + e]), /**
 * Subtract vectors.
 * @param A
 * @param B
 */
x(a, "sub", (r, e) => [r[0] - e[0], r[1] - e[1]]), /**
 * Subtract scalar from vector.
 * @param A
 * @param B
 */
x(a, "subScalar", (r, e) => [r[0] - e, r[1] - e]), /**
 * Get the vector from vectors A to B.
 * @param A
 * @param B
 */
x(a, "vec", (r, e) => [e[0] - r[0], e[1] - r[1]]), /**
 * Vector multiplication by scalar
 * @param A
 * @param n
 */
x(a, "mul", (r, e) => [r[0] * e, r[1] * e]), /**
 * Multiple two vectors.
 * @param A
 * @param B
 */
x(a, "mulV", (r, e) => [r[0] * e[0], r[1] * e[1]]), /**
 * Vector division by scalar.
 * @param A
 * @param n
 */
x(a, "div", (r, e) => [r[0] / e, r[1] / e]), /**
 * Vector division by vector.
 * @param A
 * @param n
 */
x(a, "divV", (r, e) => [r[0] / e[0], r[1] / e[1]]), /**
 * Perpendicular rotation of a vector A
 * @param A
 */
x(a, "per", (r) => [r[1], -r[0]]), /**
 * Dot product
 * @param A
 * @param B
 */
x(a, "dpr", (r, e) => r[0] * e[0] + r[1] * e[1]), /**
 * Cross product (outer product) | A X B |
 * @param A
 * @param B
 */
x(a, "cpr", (r, e) => r[0] * e[1] - e[0] * r[1]), /**
 * Length of the vector squared
 * @param A
 */
x(a, "len2", (r) => r[0] * r[0] + r[1] * r[1]), /**
 * Length of the vector
 * @param A
 */
x(a, "len", (r) => Math.hypot(r[0], r[1])), /**
 * Project A over B
 * @param A
 * @param B
 */
x(a, "pry", (r, e) => a.dpr(r, e) / a.len(e)), /**
 * Get normalized / unit vector.
 * @param A
 */
x(a, "uni", (r) => a.div(r, a.len(r))), /**
 * Get normalized / unit vector.
 * @param A
 */
x(a, "normalize", (r) => a.uni(r)), /**
 * Get the tangent between two vectors.
 * @param A
 * @param B
 * @returns
 */
x(a, "tangent", (r, e) => a.uni(a.sub(r, e))), /**
 * Dist length from A to B squared.
 * @param A
 * @param B
 */
x(a, "dist2", (r, e) => a.len2(a.sub(r, e))), /**
 * Dist length from A to B
 * @param A
 * @param B
 */
x(a, "dist", (r, e) => Math.hypot(r[1] - e[1], r[0] - e[0])), /**
 * A faster, though less accurate method for testing distances. Maybe faster?
 * @param A
 * @param B
 * @returns
 */
x(a, "fastDist", (r, e) => {
  const n = [e[0] - r[0], e[1] - r[1]], o = [Math.abs(n[0]), Math.abs(n[1])];
  let u = 1 / Math.max(o[0], o[1]);
  return u = u * (1.29289 - (o[0] + o[1]) * u * 0.29289), [n[0] * u, n[1] * u];
}), /**
 * Angle between vector A and vector B in radians
 * @param A
 * @param B
 */
x(a, "ang", (r, e) => Math.atan2(a.cpr(r, e), a.dpr(r, e))), /**
 * Angle between vector A and vector B in radians
 * @param A
 * @param B
 */
x(a, "angle", (r, e) => Math.atan2(e[1] - r[1], e[0] - r[0])), /**
 * Mean between two vectors or mid vector between two vectors
 * @param A
 * @param B
 */
x(a, "med", (r, e) => a.mul(a.add(r, e), 0.5)), /**
 * Vector rotation by r (radians)
 * @param A
 * @param r rotation in radians
 */
x(a, "rot", (r, e = 0) => [
  r[0] * Math.cos(e) - r[1] * Math.sin(e),
  r[0] * Math.sin(e) + r[1] * Math.cos(e)
]), /**
 * Rotate a vector around another vector by r (radians)
 * @param A vector
 * @param C center
 * @param r rotation in radians
 */
x(a, "rotWith", (r, e, n = 0) => {
  if (n === 0)
    return r;
  const o = Math.sin(n), u = Math.cos(n), l = r[0] - e[0], f = r[1] - e[1], g = l * u - f * o, y = l * o + f * u;
  return [g + e[0], y + e[1]];
}), /**
 * Check of two vectors are identical.
 * @param A
 * @param B
 */
x(a, "isEqual", (r, e) => r[0] === e[0] && r[1] === e[1]), /**
 * Interpolate vector A to B with a scalar t
 * @param A
 * @param B
 * @param t scalar
 */
x(a, "lrp", (r, e, n) => a.add(r, a.mul(a.sub(e, r), n))), /**
 * Interpolate from A to B when curVAL goes fromVAL: number[] => to
 * @param A
 * @param B
 * @param from Starting value
 * @param to Ending value
 * @param s Strength
 */
x(a, "int", (r, e, n, o, u = 1) => {
  const l = (a.clamp(n, o) - n) / (o - n);
  return a.add(a.mul(r, 1 - l), a.mul(e, u));
}), /**
 * Get the angle between the three vectors A, B, and C.
 * @param p1
 * @param pc
 * @param p2
 */
x(a, "ang3", (r, e, n) => {
  const o = a.vec(e, r), u = a.vec(e, n);
  return a.ang(o, u);
}), /**
 * Absolute value of a vector.
 * @param A
 * @returns
 */
x(a, "abs", (r) => [Math.abs(r[0]), Math.abs(r[1])]), x(a, "rescale", (r, e) => {
  const n = a.len(r);
  return [e * r[0] / n, e * r[1] / n];
}), /**
 * Get whether p1 is left of p2, relative to pc.
 * @param p1
 * @param pc
 * @param p2
 */
x(a, "isLeft", (r, e, n) => (e[0] - r[0]) * (n[1] - r[1]) - (n[0] - r[0]) * (e[1] - r[1])), /**
 * Get whether p1 is left of p2, relative to pc.
 * @param p1
 * @param pc
 * @param p2
 */
x(a, "clockwise", (r, e, n) => a.isLeft(r, e, n) > 0), /**
 * Round a vector to two decimal places.
 * @param a
 */
x(a, "toFixed", (r) => r.map((e) => Math.round(e * 100) / 100)), /**
 * Get the nearest point on a line with a known unit vector that passes through point A
 * @param A Any point on the line
 * @param u The unit vector for the line.
 * @param P A point not on the line to test.
 * @returns
 */
x(a, "nearestPointOnLineThroughPoint", (r, e, n) => a.add(r, a.mul(e, a.pry(a.sub(n, r), e)))), /**
 * Distance between a point and a line with a known unit vector that passes through a point.
 * @param A Any point on the line
 * @param u The unit vector for the line.
 * @param P A point not on the line to test.
 * @returns
 */
x(a, "distanceToLineThroughPoint", (r, e, n) => a.dist(n, a.nearestPointOnLineThroughPoint(r, e, n))), /**
 * Get the nearest point on a line segment between A and B
 * @param A The start of the line segment
 * @param B The end of the line segment
 * @param P The off-line point
 * @param clamp Whether to clamp the point between A and B.
 * @returns
 */
x(a, "nearestPointOnLineSegment", (r, e, n, o = !0) => {
  const u = a.uni(a.sub(e, r)), l = a.add(r, a.mul(u, a.pry(a.sub(n, r), u)));
  if (o) {
    if (l[0] < Math.min(r[0], e[0]))
      return r[0] < e[0] ? r : e;
    if (l[0] > Math.max(r[0], e[0]))
      return r[0] > e[0] ? r : e;
    if (l[1] < Math.min(r[1], e[1]))
      return r[1] < e[1] ? r : e;
    if (l[1] > Math.max(r[1], e[1]))
      return r[1] > e[1] ? r : e;
  }
  return l;
}), /**
 * Distance between a point and the nearest point on a line segment between A and B
 * @param A The start of the line segment
 * @param B The end of the line segment
 * @param P The off-line point
 * @param clamp Whether to clamp the point between A and B.
 * @returns
 */
x(a, "distanceToLineSegment", (r, e, n, o = !0) => a.dist(n, a.nearestPointOnLineSegment(r, e, n, o))), /**
 * Get the nearest point on a bounding box to a point P.
 * @param bounds The bounding box
 * @param P The point point
 * @returns
 */
x(a, "nearestPointOnBounds", (r, e) => [
  a.clamp(e[0], r.minX, r.maxX),
  a.clamp(e[1], r.minY, r.maxY)
]), /**
 * Distance between a point and the nearest point on a bounding box.
 * @param bounds The bounding box.
 * @param P The point
 * @returns
 */
x(a, "distanceToBounds", (r, e) => a.dist(e, a.nearestPointOnBounds(r, e))), /**
 * Push a point A towards point B by a given distance.
 * @param A
 * @param B
 * @param d
 * @returns
 */
x(a, "nudge", (r, e, n) => a.isEqual(r, e) ? r : a.add(r, a.mul(a.uni(a.sub(e, r)), n))), /**
 * Push a point in a given angle by a given distance.
 * @param A
 * @param B
 * @param d
 */
x(a, "nudgeAtAngle", (r, e, n) => [Math.cos(e) * n + r[0], Math.sin(e) * n + r[1]]), /**
 * Round a vector to a precision length.
 * @param a
 * @param n
 */
x(a, "toPrecision", (r, e = 4) => [+r[0].toPrecision(e), +r[1].toPrecision(e)]), /**
 * Get an array of points between two points.
 * @param A The first point.
 * @param B The second point.
 * @param steps The number of points to return.
 */
x(a, "pointsBetween", (r, e, n = 6) => Array.from(Array(n)).map((o, u) => {
  const l = u / (n - 1), f = Math.min(1, 0.5 + Math.abs(0.5 - l));
  return [...a.lrp(r, e, l), f];
})), /**
 * Get the slope between two points.
 * @param A
 * @param B
 */
x(a, "slope", (r, e) => r[0] === e[0] ? NaN : (r[1] - e[1]) / (r[0] - e[0])), /**
 * Get a vector comprised of the maximum of two or more vectors.
 */
x(a, "max", (...r) => [Math.max(...r.map((e) => e[0])), Math.max(...r.map((e) => e[1]))]), /**
 * Get a vector comprised of the minimum of two or more vectors.
 */
x(a, "min", (...r) => [Math.min(...r.map((e) => e[0])), Math.min(...r.map((e) => e[1]))]), x(a, "toVec", (r) => [r.x, r.y]), x(a, "toPoint", (r) => ({
  x: r[0],
  y: r[1]
}));
let lt = a;
function tr(t) {
  const r = t.size * 4, e = t.size * 3;
  switch (t.style) {
    case "line":
      return /* @__PURE__ */ s.jsx("g", { transform: `translate(${t.x - r} ${t.y - e / 2})`, children: /* @__PURE__ */ s.jsx(
        "path",
        {
          style: {
            transform: `rotate(${t.rotate ?? 0}deg)`,
            transformOrigin: `${r}px ${e / 2}px`
          },
          stroke: t.fill ?? "#fff",
          fill: "white",
          d: `M ${r} ${e} L 0 ${e / 2} L  ${r} 0`
        }
      ) });
    case "fill":
      return /* @__PURE__ */ s.jsx("g", { transform: `translate(${t.x - r} ${t.y - e / 2})`, children: /* @__PURE__ */ s.jsx(
        "path",
        {
          style: {
            transform: `rotate(${t.rotate ?? 0}deg)`,
            transformOrigin: `${r}px ${e / 2}px`
          },
          fill: t.fill ?? "#000",
          d: `M 0 ${e / 2} L ${r} 0 L ${r} ${e} Z`
        }
      ) });
    default:
      return;
  }
}
function rr(t) {
  const r = t.size * 2;
  let e = t.x, n = t.y;
  if (t.fromPoint) {
    const o = lt.angle(t.fromPoint, [e, n]), u = r * 1;
    e += Math.cos(o) * u, n += Math.sin(o) * u;
  }
  return t.style === "line" ? /* @__PURE__ */ s.jsx(
    "circle",
    {
      cx: e,
      cy: n,
      r,
      stroke: t.fill ?? "#000",
      fill: "white",
      strokeWidth: t.size
    }
  ) : t.style === "fill" ? /* @__PURE__ */ s.jsx("circle", { cx: e, cy: n, r, fill: t.fill ?? "#000" }) : null;
}
function ie(t) {
  const { strokeWidth: r = 4 } = t, e = t.points, n = e.slice(-2), o = e.slice(0, 2);
  return /* @__PURE__ */ s.jsxs("g", { children: [
    o && o.length === 2 && /* @__PURE__ */ s.jsx(
      tr,
      {
        x: o[0][0],
        y: o[0][1],
        size: r,
        fill: t.stroke ?? "#000",
        rotate: lt.angle(o[0], o[1]) * (180 / Math.PI),
        style: t.startArrow
      }
    ),
    n && n.length === 2 && /* @__PURE__ */ s.jsx(
      tr,
      {
        x: n[1][0],
        y: n[1][1],
        size: r,
        fill: t.stroke ?? "#000",
        rotate: lt.angle(n[0], n[1]) * (180 / Math.PI) + 180,
        style: t.endArrow
      }
    ),
    t.startDot && t.startDot !== "none" && o && /* @__PURE__ */ s.jsx(
      rr,
      {
        x: o[0][0],
        y: o[0][1],
        size: r,
        fill: t.stroke ?? "#000",
        style: t.startDot,
        fromPoint: o[1]
      }
    ),
    t.endDot && t.endDot !== "none" && n && /* @__PURE__ */ s.jsx(
      rr,
      {
        x: n[1][0],
        y: n[1][1],
        size: r,
        fill: t.stroke ?? "#000",
        style: t.endDot,
        fromPoint: n[0]
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        strokeWidth: r + 20,
        fill: "none",
        stroke: "transparent",
        d: e.reduce((u, l, f) => f === 0 ? `M ${l[0]} ${l[1]}` : u + ` L ${l[0]} ${l[1]}`, "")
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        stroke: t.stroke ?? "#000",
        strokeWidth: r,
        fill: "none",
        strokeDasharray: t.strokeStyle && j(t.strokeStyle),
        d: e.reduce((u, l, f) => f === 0 ? `M ${l[0]} ${l[1]}` : u + ` L ${l[0]} ${l[1]}`, "")
      }
    )
  ] });
}
function oe(t) {
  const { id: r, element: e } = G(
    t.width,
    t.height,
    t.strokeWidth
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e,
    /* @__PURE__ */ s.jsxs(
      "g",
      {
        clipPath: `url(#clip_${r})`,
        style: {
          transformOrigin: `${t.x + t.width / 2}px ${t.y + t.height / 2}px`,
          rotate: `${t.rotate ?? 0}deg`
        },
        children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              stroke: t.stroke,
              strokeWidth: t.strokeWidth,
              fill: t.fill ?? "#000",
              strokeDasharray: t.strokeStyle && j(t.strokeStyle),
              d: t.points.reduce((n, o, u) => u === 0 ? `M ${o[0]} ${o[1]}` : n + ` L ${o[0]} ${o[1]}`, "") + " Z"
            }
          ),
          t.text && /* @__PURE__ */ s.jsx(
            "g",
            {
              style: {
                transform: `translate(${t.x}px, ${t.y}px)`
              },
              children: /* @__PURE__ */ s.jsx(
                N,
                {
                  text: t.text,
                  width: t.width,
                  height: t.height,
                  textColor: t.textColor,
                  textSize: t.textSize,
                  textAlign: t.textAlign
                }
              )
            }
          )
        ]
      }
    )
  ] });
}
function se(t) {
  const r = Q(t.mode).with("cover", () => "xMidYMid slice").with("contain", () => "xMidYMid").with("stretch", () => "none").otherwise(() => "xMidYMid slice");
  return /* @__PURE__ */ s.jsxs(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: [
        /* @__PURE__ */ s.jsx(
          "rect",
          {
            width: t.width,
            height: t.height,
            strokeWidth: t.strokeWidth ?? 0,
            stroke: t.stroke,
            fill: "#ddd",
            strokeDasharray: t.strokeStyle && j(t.strokeStyle)
          }
        ),
        /* @__PURE__ */ s.jsx(
          "g",
          {
            style: {
              transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
              transformOrigin: `${t.width / 2}px ${t.height / 2}px`
            },
            children: t.image ? /* @__PURE__ */ s.jsx(
              "image",
              {
                preserveAspectRatio: r,
                href: t.image,
                width: t.width,
                height: t.height
              }
            ) : /* @__PURE__ */ s.jsxs(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x: t.width / 2 - 12,
                y: t.height / 2 - 12,
                children: [
                  /* @__PURE__ */ s.jsx("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }),
                  /* @__PURE__ */ s.jsx("circle", { cx: "9", cy: "9", r: "2" }),
                  /* @__PURE__ */ s.jsx("path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" })
                ]
              }
            )
          }
        )
      ]
    }
  );
}
function ur(t) {
  var r, e, n = "";
  if (typeof t == "string" || typeof t == "number")
    n += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (r = 0; r < t.length; r++)
        t[r] && (e = ur(t[r])) && (n && (n += " "), n += e);
    else
      for (r in t)
        t[r] && (n && (n += " "), n += r);
  return n;
}
function le() {
  for (var t, r, e = 0, n = ""; e < arguments.length; )
    (t = arguments[e++]) && (r = ur(t)) && (n && (n += " "), n += r);
  return n;
}
function ae(t, r) {
  return console.log(t, "shape"), /* @__PURE__ */ s.jsxs(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: [
        /* @__PURE__ */ s.jsx(
          "rect",
          {
            className: le({
              hotarea_hover: r
            }),
            width: t.width,
            height: t.height,
            fill: t.fill,
            rx: t.radius,
            strokeWidth: t.strokeWidth ?? 0,
            stroke: t.stroke,
            strokeDasharray: t.strokeStyle && j(t.strokeStyle)
          }
        ),
        t.text && /* @__PURE__ */ s.jsx(
          N,
          {
            text: t.text,
            width: t.width,
            height: t.height,
            textColor: t.textColor,
            textSize: t.textSize,
            textAlign: t.textAlign
          }
        )
      ]
    }
  );
}
function ue(t, r, e = "right") {
  const n = Q(e).with("right", () => [
    [0.8, 0],
    [1, 0.5],
    [0.8, 1],
    [0, 1],
    [0, 0]
  ]).with("left", () => [
    [0.2, 0],
    [0, 0.5],
    [0.2, 1],
    [1, 1],
    [1, 0]
  ]).with("top", () => [
    [0.5, 0],
    [1, 0.2],
    [1, 1],
    [0, 1],
    [0, 0.2]
  ]).with("bottom", () => [
    [0, 0],
    [1, 0],
    [1, 0.8],
    [0.5, 1],
    [0, 0.8]
  ]).otherwise(() => []);
  return n.reduce((u, l, f) => f === 0 ? `M ${l[0] * t} ${l[1] * r}` : `${u} L ${l[0] * t} ${l[1] * r} ${f === n.length - 1 ? "Z" : ""}`, "");
}
function ce(t) {
  const { id: r, element: e } = G(
    t.width,
    t.height,
    t.strokeWidth
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e,
    /* @__PURE__ */ s.jsxs(
      "g",
      {
        clipPath: `url(#clip_${r})`,
        style: {
          transform: `translate(${t.x}px, ${t.y}px)`,
          transformOrigin: `${t.width / 2}px ${t.height / 2}px`
        },
        children: [
          /* @__PURE__ */ s.jsx(
            "g",
            {
              style: {
                transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
                transformOrigin: `${t.width / 2}px ${t.height / 2}px`
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  d: ue(t.width, t.height, t.direction),
                  fill: t.fill,
                  stroke: t.stroke,
                  strokeWidth: t.strokeWidth ?? 1,
                  strokeDasharray: t.strokeStyle && j(t.strokeStyle)
                }
              )
            }
          ),
          t.text && /* @__PURE__ */ s.jsx(
            N,
            {
              text: t.text,
              width: t.width,
              height: t.height,
              textColor: t.textColor,
              textSize: t.textSize,
              textAlign: t.textAlign
            }
          )
        ]
      }
    )
  ] });
}
function fe(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          strokeWidth: t.strokeWidth ?? 1,
          stroke: t.stroke ?? "#000",
          d: de(t.width, t.height),
          fill: "rgba(0,0,0,0)",
          strokeDasharray: t.strokeStyle && j(t.strokeStyle)
        }
      )
    }
  );
}
function de(t, r) {
  return [
    {
      type: "M",
      points: [0.06, 0.56]
    },
    {
      type: "v",
      points: [0, -0.12]
    },
    {
      type: "C",
      points: [0.06, 0, 0.28, 0, 0.28, 0.44]
    },
    {
      type: "C",
      points: [0.28, 0, 0.5, 0.02, 0.5, 0.44]
    },
    {
      type: "C",
      points: [0.5, 0, 0.72, 0, 0.72, 0.44]
    },
    {
      type: "C",
      points: [0.72, 0, 0.94, 0, 0.94, 0.44]
    },
    {
      type: "C",
      points: [0.94, 0.44, 0.94, 0.5, 0.94, 0.56]
    }
  ].reduce((n, o) => `${n} ${o.type} ${o.points.map((u, l) => u * (l % 2 === 0 ? t : r)).join(",")}`, "");
}
function ge(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsx(
        "g",
        {
          style: {
            transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
            transformOrigin: `${t.width / 2}px ${t.height / 2}px`
          },
          children: /* @__PURE__ */ s.jsxs("g", { children: [
            /* @__PURE__ */ s.jsx(
              "path",
              {
                strokeWidth: t.strokeWidth ?? 1,
                stroke: t.stroke ?? "#000",
                d: er(t.width, t.height)[0],
                fill: "rgba(0,0,0,0)",
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                strokeWidth: t.strokeWidth ?? 1,
                stroke: t.stroke ?? "#000",
                d: er(t.width, t.height)[1],
                fill: "rgba(0,0,0,0)",
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            )
          ] })
        }
      )
    }
  );
}
function er(t, r) {
  const e = [
    {
      type: "M",
      points: [0.5, 0]
    },
    {
      type: "v",
      points: [0, 0.4]
    },
    {
      type: "L",
      points: [0.3, 0.4]
    },
    {
      type: "L",
      points: [0.7, 0.4]
    }
  ], n = [
    {
      type: "M",
      points: [0.5, 1]
    },
    {
      type: "v",
      points: [0, -0.45]
    },
    {
      type: "L",
      points: [0.4, 0.55]
    },
    {
      type: "L",
      points: [0.6, 0.55]
    }
  ], o = e.reduce((l, f) => `${l} ${f.type} ${f.points.map((g, y) => g * (y % 2 === 0 ? t : r)).join(",")}`, ""), u = n.reduce((l, f) => `${l} ${f.type} ${f.points.map((g, y) => g * (y % 2 === 0 ? t : r)).join(",")}`, "");
  return [o, u];
}
function ye(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsx(
        "g",
        {
          style: {
            transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
            transformOrigin: `${t.width / 2}px ${t.height / 2}px`
          },
          children: /* @__PURE__ */ s.jsx(
            "path",
            {
              strokeWidth: t.strokeWidth ?? 1,
              stroke: t.stroke ?? "#000",
              d: xe(t.width, t.height),
              fill: "rgba(0,0,0,0)",
              strokeDasharray: t.strokeStyle && j(t.strokeStyle)
            }
          )
        }
      )
    }
  );
}
function xe(t, r) {
  return [
    {
      type: "M",
      points: [0, 0.5]
    },
    {
      type: "L",
      points: [0.325, 0.5]
    },
    {
      type: "v",
      points: [0.25]
    },
    {
      type: "M",
      points: [0.325, 0.5]
    },
    {
      type: "L",
      points: [0.43, 0.5]
    },
    {
      type: "L",
      points: [0.46, 0.4]
    },
    {
      type: "L",
      points: [0.49, 0.6]
    },
    {
      type: "L",
      points: [0.52, 0.4]
    },
    {
      type: "L",
      points: [0.55, 0.6]
    },
    {
      type: "L",
      points: [0.58, 0.4]
    },
    {
      type: "L",
      points: [0.61, 0.6]
    },
    {
      type: "L",
      points: [0.64, 0.5]
    },
    {
      type: "L",
      points: [0.725, 0.5]
    },
    {
      type: "v",
      points: [0.25]
    },
    {
      type: "M",
      points: [0.675, 0.5]
    },
    {
      type: "L",
      points: [1, 0.5]
    }
  ].reduce((n, o) => `${n} ${o.type} ${o.points.map((u, l) => u * (l % 2 === 0 ? t : r)).join(",")}`, "");
}
function he(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)
`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsx(
        "g",
        {
          style: {
            transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
            transformOrigin: `${t.width / 2}px ${t.height / 2}px`
          },
          children: /* @__PURE__ */ s.jsx(
            "path",
            {
              strokeWidth: t.strokeWidth ?? 1,
              stroke: t.stroke ?? "#000",
              d: me(t.width, t.height),
              fill: "rgba(0,0,0,0)",
              strokeDasharray: t.strokeStyle && j(t.strokeStyle)
            }
          )
        }
      )
    }
  );
}
function me(t, r) {
  return [
    {
      type: "M",
      points: [0, 0.5]
    },
    {
      type: "H",
      points: [0.45]
    },
    {
      type: "C",
      points: [0.45, 0.5, 0.45, 0.45, 0.5, 0.45]
    },
    {
      type: "C",
      points: [0.55, 0.45, 0.55, 0.5, 0.55, 0.5]
    },
    {
      type: "H",
      points: [1]
    },
    {
      type: "M",
      points: [0.5, 1]
    },
    {
      type: "L",
      points: [0.5, 0]
    }
    // {
    //   type: "L",
    //   points: [0.4, 0],
    // },
    // {
    //   type: "M",
    //   points: [0.35, 0.5],
    // },
    // {
    //   type: "M",
    //   points: [0, 0.5],
    // },
    // {
    //   type: "L",
    //   points: [0.35, 0.5],
    // },
    // {
    //   type: "M",
    //   points: [0.45, 0.5],
    // },
    // {
    //   type: "L",
    //   points: [1, 0.5],
    // },
    // {
    //   type: "M",
    //   points: [0.4, 1],
    // },
    // {
    //   type: "L",
    //   points: [0.4, 0],
    // },
    // {
    //   type: "M",
    //   points: [0.35, 0.5],
    // },
    // {
    //   type: "T",
    //   points: [0.45,0.5],
    // },
    // {
    //   type: "A",
    //   points: [0.05,0.05,0,0,1,0.45,0.5],
    // },
  ].reduce((n, o) => `${n} ${o.type} ${o.points.map((u, l) => u * (l % 2 === 0 ? t : r)).join(",")}`, "");
}
function $e(t, r, e = "right") {
  const n = Q(e).with("right", () => [
    [0, 1],
    [1, 0.7],
    [1, 0.3],
    [0, 0]
  ]).with("left", () => [
    [0, 0.3],
    [0, 0.7],
    [1, 1],
    [1, 0]
  ]).with("top", () => [
    [0.3, 0],
    [0.7, 0],
    [1, 1],
    [0, 1]
  ]).with("bottom", () => [
    [0, 0],
    [1, 0],
    [0.7, 1],
    [0.3, 1]
  ]).otherwise(() => []);
  return n.reduce((u, l, f) => f === 0 ? `M ${l[0] * t} ${l[1] * r}` : `${u} L ${l[0] * t} ${l[1] * r} ${f === n.length - 1 ? "Z" : ""}`, "");
}
function ke(t) {
  const { id: r, element: e } = G(
    t.width,
    t.height,
    t.strokeWidth
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e,
    /* @__PURE__ */ s.jsxs(
      "g",
      {
        clipPath: `url(#clip_${r})`,
        style: {
          transform: `translate(${t.x}px, ${t.y}px)`,
          transformOrigin: `${t.width / 2}px ${t.height / 2}px`
        },
        children: [
          /* @__PURE__ */ s.jsx(
            "g",
            {
              style: {
                transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
                transformOrigin: `${t.width / 2}px ${t.height / 2}px`
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  d: $e(t.width, t.height, t.direction),
                  fill: t.fill,
                  stroke: t.stroke,
                  strokeWidth: t.strokeWidth ?? 1,
                  strokeDasharray: t.strokeStyle && j(t.strokeStyle)
                }
              )
            }
          ),
          t.text && /* @__PURE__ */ s.jsx(
            N,
            {
              text: t.text,
              width: t.width,
              height: t.height,
              textColor: t.textColor,
              textSize: t.textSize,
              textAlign: t.textAlign
            }
          )
        ]
      }
    )
  ] });
}
function ve(t, r, e = "right") {
  const n = Q(e).with("right", () => [
    [0, 0.4],
    [0, 0.6],
    [0.7, 0.6],
    [0.7, 0.8],
    [1, 0.5],
    [0.7, 0.2],
    [0.7, 0.4],
    [0, 0.4]
  ]).with("left", () => [
    [0, 0.5],
    [0.3, 0.8],
    [0.3, 0.6],
    [1, 0.6],
    [1, 0.4],
    [0.3, 0.4],
    [0.3, 0.2],
    [0, 0.5]
  ]).with("top", () => [
    [0.5, 0],
    [0.8, 0.3],
    [0.6, 0.3],
    [0.6, 1],
    [0.4, 1],
    [0.4, 0.3],
    [0.2, 0.3],
    [0.5, 0]
  ]).with("bottom", () => [
    [0.4, 0],
    [0.6, 0],
    [0.6, 0.7],
    [0.8, 0.7],
    [0.5, 1],
    [0.2, 0.7],
    [0.4, 0.7],
    [0.4, 0]
  ]).otherwise(() => []);
  return n.reduce((u, l, f) => f === 0 ? `M ${l[0] * t} ${l[1] * r}` : `${u} L ${l[0] * t} ${l[1] * r} ${f === n.length - 1 ? "Z" : ""}`, "");
}
function we(t) {
  const { id: r, element: e } = G(
    t.width,
    t.height,
    t.strokeWidth
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e,
    /* @__PURE__ */ s.jsxs(
      "g",
      {
        clipPath: `url(#clip_${r})`,
        style: {
          transform: `translate(${t.x}px, ${t.y}px)`,
          transformOrigin: `${t.width / 2}px ${t.height / 2}px`
        },
        children: [
          /* @__PURE__ */ s.jsx(
            "g",
            {
              style: {
                transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
                transformOrigin: `${t.width / 2}px ${t.height / 2}px`
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  d: ve(t.width, t.height, t.direction),
                  fill: t.fill,
                  stroke: t.stroke,
                  strokeWidth: t.strokeWidth ?? 1,
                  strokeDasharray: t.strokeStyle && j(t.strokeStyle)
                }
              )
            }
          ),
          t.text && /* @__PURE__ */ s.jsx(
            N,
            {
              text: t.text,
              width: t.width,
              height: t.height,
              textColor: t.textColor,
              textSize: t.textSize,
              textAlign: t.textAlign
            }
          )
        ]
      }
    )
  ] });
}
function pe(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsx(
        "g",
        {
          style: {
            transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
            transformOrigin: `${t.width / 4}px ${t.height / 2}px`
          },
          children: /* @__PURE__ */ s.jsxs("g", { children: [
            /* @__PURE__ */ s.jsx(
              "path",
              {
                stroke: t.stroke ?? "#000",
                d: ot(t.width, t.height)[0],
                fill: "rgba(227,227,227,1)",
                strokeWidth: t.strokeWidth ?? 1,
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                stroke: t.stroke ?? "#000",
                d: ot(t.width, t.height)[1],
                fill: "rgba(227,227,227,1)",
                strokeWidth: t.strokeWidth ?? 1,
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                stroke: t.stroke ?? "#000",
                d: ot(t.width, t.height)[2],
                fill: "rgba(0,0,0,0)",
                strokeWidth: t.strokeWidth ?? 1,
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                stroke: t.stroke ?? "#000",
                d: ot(t.width, t.height)[3],
                fill: "rgba(0,0,0,0)",
                strokeWidth: t.strokeWidth ?? 1,
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                stroke: t.stroke ?? "#000",
                d: ot(t.width, t.height)[4],
                fill: "rgba(0,0,0,0)",
                strokeWidth: t.strokeWidth ?? 1,
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            )
          ] })
        }
      )
    }
  );
}
function ot(t, r) {
  const e = [
    {
      type: "M",
      points: [0, 0.4]
    },
    {
      type: "L",
      points: [0, 0.6]
    },
    {
      type: "L",
      points: [0.1, 0.6]
    },
    {
      type: "L",
      points: [0.1, 0.4]
    },
    {
      type: "L",
      points: [0, 0.4]
    }
  ], n = [
    {
      type: "M",
      points: [0.1, 0.4]
    },
    {
      type: "L",
      points: [0.1, 0.6]
    },
    {
      type: "L",
      points: [0.3, 0.8]
    },
    {
      type: "L",
      points: [0.3, 0.2]
    },
    {
      type: "L",
      points: [0.1, 0.4]
    }
  ], o = [
    {
      type: "M",
      points: [0.35, 0.6]
    },
    {
      type: "S",
      points: [0.4, 0.5, 0.35, 0.4]
    }
  ], u = [
    {
      type: "M",
      points: [0.4, 0.65]
    },
    {
      type: "S",
      points: [0.45, 0.5, 0.4, 0.35]
    }
  ], l = [
    {
      type: "M",
      points: [0.45, 0.7]
    },
    {
      type: "S",
      points: [0.5, 0.5, 0.45, 0.3]
    }
  ], f = e.reduce((b, E) => `${b} ${E.type} ${E.points.map((T, L) => T * (L % 2 === 0 ? t : r)).join(",")}`, ""), g = n.reduce((b, E) => `${b} ${E.type} ${E.points.map((T, L) => T * (L % 2 === 0 ? t : r)).join(",")}`, ""), y = o.reduce((b, E) => `${b} ${E.type} ${E.points.map((T, L) => T * (L % 2 === 0 ? t : r)).join(",")}`, ""), k = u.reduce((b, E) => `${b} ${E.type} ${E.points.map((T, L) => T * (L % 2 === 0 ? t : r)).join(",")}`, ""), R = l.reduce((b, E) => `${b} ${E.type} ${E.points.map((T, L) => T * (L % 2 === 0 ? t : r)).join(",")}`, "");
  return [f, g, y, k, R];
}
function je(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsxs(
        "g",
        {
          style: {
            transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
            transformOrigin: `${t.width / 2}px ${t.height / 2}px`
          },
          children: [
            /* @__PURE__ */ s.jsx(
              "path",
              {
                stroke: t.stroke ?? "#000",
                strokeWidth: t.strokeWidth ?? 1,
                d: nr(t.width, t.height)[0],
                fill: "rgba(0,0,0,0)",
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                strokeWidth: t.strokeWidth ?? 1,
                stroke: t.stroke ?? "#000",
                d: nr(t.width, t.height)[1],
                fill: "rgba(0,0,0,0)",
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            )
          ]
        }
      )
    }
  );
}
function nr(t, r) {
  const e = [
    {
      type: "M",
      points: [0, 1]
    },
    {
      type: "L",
      points: [0.14, 1]
    },
    {
      type: "S",
      points: [0.25, 0.7, 0.36, 1]
    },
    {
      type: "M",
      points: [0.36, 1]
    },
    {
      type: "S",
      points: [0.47, 0.7, 0.58, 1]
    },
    {
      type: "M",
      points: [0.58, 1]
    },
    {
      type: "S",
      points: [0.69, 0.7, 0.8, 1]
    },
    {
      type: "M",
      points: [0.8, 1]
    },
    {
      type: "L",
      points: [1, 1]
    }
  ], n = [
    {
      type: "M",
      points: [0, 0.6]
    },
    {
      type: "L",
      points: [0.11, 0.6]
    },
    {
      type: "M",
      points: [0.22, 0.6]
    },
    {
      type: "L",
      points: [0.33, 0.6]
    },
    {
      type: "M",
      points: [0.44, 0.6]
    },
    {
      type: "L",
      points: [0.55, 0.6]
    },
    {
      type: "M",
      points: [0.66, 0.6]
    },
    {
      type: "L",
      points: [0.77, 0.6]
    },
    {
      type: "M",
      points: [0.88, 0.6]
    },
    {
      type: "L",
      points: [0.99, 0.6]
    }
  ], o = e.reduce((l, f) => `${l} ${f.type} ${f.points.map((g, y) => g * (y % 2 === 0 ? t : r)).join(",")}`, ""), u = n.reduce((l, f) => `${l} ${f.type} ${f.points.map((g, y) => g * (y % 2 === 0 ? t : r)).join(",")}`, "");
  return [o, u];
}
function Se(t, r, e = "right") {
  const n = Q(e).with("right", () => [
    [0, 0],
    [0, 1],
    [1, 0.5]
  ]).with("left", () => [
    [1, 0],
    [1, 1],
    [0, 0.5]
  ]).with("top", () => [
    [0.5, 0],
    [1, 1],
    [0, 1]
  ]).with("bottom", () => [
    [0, 0],
    [1, 0],
    [0.5, 1]
  ]).otherwise(() => []);
  return n.reduce((u, l, f) => f === 0 ? `M ${l[0] * t} ${l[1] * r}` : `${u} L ${l[0] * t} ${l[1] * r} ${f === n.length - 1 ? "Z" : ""}`, "");
}
function be(t) {
  const { id: r, element: e } = G(
    t.width,
    t.height,
    t.strokeWidth
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e,
    /* @__PURE__ */ s.jsxs(
      "g",
      {
        clipPath: `url(#clip_${r})`,
        style: {
          transform: `translate(${t.x}px, ${t.y}px)`,
          transformOrigin: `${t.width / 2}px ${t.height / 2}px`
        },
        children: [
          /* @__PURE__ */ s.jsx(
            "g",
            {
              style: {
                transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
                transformOrigin: `${t.width / 2}px ${t.height / 2}px`
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  d: Se(t.width, t.height, t.direction),
                  fill: t.fill,
                  stroke: t.stroke,
                  strokeWidth: t.strokeWidth ?? 1,
                  strokeDasharray: t.strokeStyle && j(t.strokeStyle)
                }
              )
            }
          ),
          t.text && /* @__PURE__ */ s.jsx(
            N,
            {
              text: t.text,
              width: t.width,
              height: t.height,
              textColor: t.textColor,
              textSize: t.textSize,
              textAlign: t.textAlign
            }
          )
        ]
      }
    )
  ] });
}
function Ee(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          strokeWidth: t.strokeWidth ?? 1,
          stroke: t.stroke ?? "#000",
          d: Oe(t.width, t.height),
          fill: "rgba(0,0,0,0)",
          strokeDasharray: t.strokeStyle && j(t.strokeStyle)
        }
      )
    }
  );
}
function Oe(t, r) {
  return [
    {
      type: "M",
      points: [0, 0.5]
    },
    {
      type: "L",
      points: [0.3, 0.5]
    },
    {
      type: "L",
      points: [0.34, 0.6]
    },
    {
      type: "L",
      points: [0.42, 0.4]
    },
    {
      type: "L",
      points: [0.5, 0.6]
    },
    {
      type: "L",
      points: [0.58, 0.4]
    },
    {
      type: "L",
      points: [0.66, 0.6]
    },
    {
      type: "L",
      points: [0.7, 0.5]
    },
    {
      type: "L",
      points: [1, 0.5]
    }
  ].reduce((n, o) => `${n} ${o.type} ${o.points.map((u, l) => u * (l % 2 === 0 ? t : r)).join(",")}`, "");
}
function Pe(t) {
  const { id: r, element: e } = G(
    t.width,
    t.height,
    t.strokeWidth
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    e,
    /* @__PURE__ */ s.jsxs(
      "g",
      {
        clipPath: `url(#clip_${r})`,
        style: {
          transform: `translate(${t.x}px, ${t.y}px) rotate(${t.rotate ?? 0}deg)`,
          transformOrigin: `${t.width / 2}px ${t.height / 2}px`
        },
        children: [
          /* @__PURE__ */ s.jsx(
            "ellipse",
            {
              cx: t.width / 2,
              cy: t.height / 6 * 1,
              fill: t.fill,
              rx: t.width / 2 / 3 * 0.9,
              ry: t.height / 2 / 3 * 0.9,
              strokeWidth: t.strokeWidth ?? 0,
              stroke: t.stroke
            }
          ),
          /* @__PURE__ */ s.jsx(
            "ellipse",
            {
              cx: t.width / 2,
              cy: t.height / 6 * 3,
              fill: t.fill,
              rx: t.width / 2 / 3 * 0.9,
              ry: t.height / 2 / 3 * 0.9,
              strokeWidth: t.strokeWidth ?? 0,
              stroke: t.stroke
            }
          ),
          /* @__PURE__ */ s.jsx(
            "ellipse",
            {
              cx: t.width / 2,
              cy: t.height / 6 * 5,
              fill: t.fill,
              rx: t.width / 2 / 3 * 0.9,
              ry: t.height / 2 / 3 * 0.9,
              strokeWidth: t.strokeWidth ?? 0,
              stroke: t.stroke
            }
          ),
          t.text && /* @__PURE__ */ s.jsx(
            N,
            {
              text: t.text,
              width: t.width,
              height: t.height,
              textColor: t.textColor,
              textSize: t.textSize,
              textAlign: t.textAlign
            }
          )
        ]
      }
    )
  ] });
}
function Re(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsxs(
        "g",
        {
          style: {
            transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
            transformOrigin: `${t.width / 2}px ${t.height / 2}px`
          },
          children: [
            /* @__PURE__ */ s.jsx(
              "path",
              {
                stroke: t.stroke ?? "#000",
                d: ir(t.width, t.height)[0],
                fill: "none",
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                stroke: t.stroke ?? "#000",
                d: ir(t.width, t.height)[1],
                fill: "none",
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            )
          ]
        }
      )
    }
  );
}
function ir(t, r) {
  const e = [
    {
      type: "M",
      points: [0, 0]
    },
    {
      type: "A",
      points: [0.5, 0.5, 0, 0, 1, 0, 1]
    }
  ], n = [
    {
      type: "M",
      points: [1, 0]
    },
    {
      type: "A",
      points: [0.5, 0.5, 0, 0, 0, 1, 1]
    }
  ], o = e.reduce((l, f) => f.type === "A" ? `${l} ${f.type}  ${f.points.map((g, y) => y === 0 || y === 1 || y === 5 || y === 6 ? g * (y % 2 === 0 ? t : r) : g)}` : `${l} ${f.type} ${f.points.map((g, y) => g * (y % 2 === 0 ? t : r)).join(",")}`, ""), u = n.reduce((l, f) => f.type === "A" ? `${l} ${f.type}  ${f.points.map((g, y) => y === 0 || y === 1 || y === 5 || y === 6 ? g * (y % 2 === 0 ? t : r) : g)}` : `${l} ${f.type} ${f.points.map((g, y) => g * (y % 2 === 0 ? t : r)).join(",")}`, "");
  return [o, u];
}
function Me(t) {
  const { x: r, y: e, width: n, height: o, stroke: u, strokeWidth: l = 4 } = t, f = Ce(n, o);
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${r}px, ${e}px)`,
        transformOrigin: `${n / 2}px ${o / 2}px`
      },
      children: /* @__PURE__ */ s.jsx(
        "g",
        {
          style: {
            transform: `rotate(${t.rotate ?? 0}deg)`,
            transformOrigin: `${n / 2}px ${o / 2}px`
          },
          children: f.map((g, y) => /* @__PURE__ */ s.jsx(
            "path",
            {
              d: g,
              stroke: u ?? "#000",
              strokeWidth: l,
              fill: "none"
            },
            y
          ))
        }
      )
    }
  );
}
function Ce(t, r) {
  const e = t * 0.1, n = [
    t * 0.6,
    // 第一条线最宽
    t * 0.5,
    // 第二条线宽度为50%
    t * 0.3
    // 第三条线宽度为30%
  ], o = n[0] * 0.8, u = [
    {
      type: "M",
      points: [0.5, e / r]
      // 从第一条横线开始
    },
    {
      type: "L",
      points: [0.5, (e - o) / r]
      // 向上延伸
    }
  ], l = n.map((y, k) => [
    {
      type: "M",
      points: [
        0.5 - y / t / 2,
        e / r + k * e / r
      ]
    },
    {
      type: "L",
      points: [
        0.5 + y / t / 2,
        e / r + k * e / r
      ]
    }
  ]), f = u.reduce((y, k) => `${y} ${k.type} ${k.points.map((R, b) => R * (b % 2 === 0 ? t : r)).join(",")}`, ""), g = l.map(
    (y) => y.reduce((k, R) => `${k} ${R.type} ${R.points.map((b, E) => b * (E % 2 === 0 ? t : r)).join(",")}`, "")
  );
  return [f, ...g];
}
function Te(t) {
  return /* @__PURE__ */ s.jsx(
    "g",
    {
      style: {
        transform: `translate(${t.x}px, ${t.y}px) rotate(${(t.rotate ?? 0) + 90}deg)`,
        transformOrigin: `${t.width / 2}px ${t.height / 2}px`
      },
      children: /* @__PURE__ */ s.jsx(
        "g",
        {
          style: {
            transform: `${t.xFliped ? "rotateY(180deg)" : ""} ${t.yFliped ? "rotateX(180deg)" : ""}`,
            transformOrigin: `${t.width / 2}px ${t.height / 2}px`
          },
          children: /* @__PURE__ */ s.jsxs("g", { children: [
            /* @__PURE__ */ s.jsx(
              "path",
              {
                strokeWidth: t.strokeWidth ?? 1,
                stroke: t.stroke ?? "#000",
                d: or(t.width, t.height)[0],
                fill: "none",
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            ),
            /* @__PURE__ */ s.jsx(
              "path",
              {
                strokeWidth: t.strokeWidth ?? 1,
                stroke: t.stroke ?? "#000",
                d: or(t.width, t.height)[1],
                fill: "none",
                strokeDasharray: t.strokeStyle && j(t.strokeStyle)
              }
            )
          ] })
        }
      )
    }
  );
}
function or(t, r) {
  const e = [
    {
      type: "M",
      points: [0.5, 0]
    },
    {
      type: "v",
      points: [0, 0.4]
    },
    {
      type: "L",
      points: [0.3, 0.4]
    },
    {
      type: "L",
      points: [0.7, 0.4]
    }
  ], n = [
    {
      type: "M",
      points: [0.5, 1]
    },
    {
      type: "v",
      points: [0, -0.4]
    },
    {
      type: "L",
      points: [0.3, 0.6]
    },
    {
      type: "L",
      points: [0.7, 0.6]
    }
  ], o = e.reduce((l, f) => `${l} ${f.type} ${f.points.map((g, y) => g * (y % 2 === 0 ? t : r)).join(",")}`, ""), u = n.reduce((l, f) => `${l} ${f.type} ${f.points.map((g, y) => g * (y % 2 === 0 ? t : r)).join(",")}`, "");
  return [o, u];
}
function We(t, r = !1) {
  return Q(t).with({ _type: "rect" }, (e) => Vr(e)).with({ _type: "circle" }, (e) => te(e)).with({ _type: "text" }, (e) => Br(e)).with({ _type: "line" }, (e) => ie(e)).with({ _type: "polygon" }, (e) => oe(e)).with({ _type: "image" }, (e) => se(e)).with({ _type: "hotarea" }, (e) => ae(e, r)).with({ _type: "custom_adc" }, (e) => ce(e)).with({ _type: "custom_transformer" }, (e) => fe(e)).with({ _type: "custom_battery" }, (e) => ge(e)).with({ _type: "custom_polyline" }, (e) => ye(e)).with({ _type: "custom_circularArcIntersection" }, (e) => he(e)).with({ _type: "custom_trapezoid" }, (e) => ke(e)).with({ _type: "custom_arrow" }, (e) => we(e)).with({ _type: "custom_sound" }, (e) => pe(e)).with({ _type: "custom_wavy" }, (e) => je(e)).with({ _type: "custom_triangle" }, (e) => be(e)).with({ _type: "custom_tilde" }, (e) => Ee(e)).with({ _type: "custom_threeCircles" }, (e) => Pe(e)).with({ _type: "custom_xPatten" }, (e) => Re(e)).with({ _type: "custom_ground" }, (e) => Me(e)).with({ _type: "custom_capacitor" }, (e) => Te(e)).otherwise(() => null);
}
function _e(t) {
  var r, e, n, o, u, l, f;
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      viewBox: `0 0 ${((r = t.graph) == null ? void 0 : r.width) ?? 1280} ${((e = t.graph) == null ? void 0 : e.height) ?? 720}`,
      width: ((n = t.graph) == null ? void 0 : n.width) ?? "100%",
      height: ((o = t.graph) == null ? void 0 : o.height) ?? "100%",
      children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx(
          "rect",
          {
            width: (u = t.graph) == null ? void 0 : u.width,
            height: (l = t.graph) == null ? void 0 : l.height,
            fill: "#fff"
          }
        ),
        (f = t.graph) == null ? void 0 : f.shape.map((g) => /* @__PURE__ */ s.jsx(
          "g",
          {
            style: {
              pointerEvents: g._type === "hotarea" ? "auto" : "none"
            },
            onClick: (y) => {
              var k;
              g._type === "hotarea" && (y.stopPropagation(), (k = t.onClick) == null || k.call(t, g));
            },
            children: We(g, !0)
          },
          g._id
        ))
      ] })
    }
  );
}
export {
  _e as default
};
